import { render } from "./TaskCard.vue?vue&type=template&id=72a062e6"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"
script.render = render

export default script